
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import ListItem from './ListItem';
import ModalPopover from './../../../../../components/ZUILib/ModalPopover';
import InputButton from '../../../../../components/ZUILib/InputButton';
import RadioButton from './../../../../../components/ZUILib/RadioButton';
import Image from './../../../../../components/ZUILib/Image';
import Warning from './../../../../../components/Warning';
import Counter from './../../../../../components/ZUILib/Counter';
import Tagging from '../../../../../components/Tagging';
import serverClientUtil from '../../../../../utils/serverClientUtil';
import commonUtil from '../../../../../utils/commonUtil';
import * as BrowseAndNevigateMiniCartAction from '../../../../../pages/BrowseAndNavigate/MiniCart/actions';
import * as giftListGuestViewAction from '../actions';
import { closeWebGiftListIcon, deleteWebModalIcon ,AddWebModalIcon,starWebGiftListIcon ,helpWebGiftListIcon } from '../../../../../components/NewHeader/Header/svgIcons';
import TextInput from '../../../../../components/ZUILib/TextInput/TextInput';

const { getCartCountData } = BrowseAndNevigateMiniCartAction;
const { additemtocart, additemtoexpresscart, getConfiguration } = giftListGuestViewAction;

class ListContainer extends Component {
  constructor(props) {
    super(props);
    this.gifteeRefs = [];
    this.itemInfo = {};
    this.getAddressObject = {};
    this.quantity = 1;
    this.eventId = this.props.eventId;
    this.guestViewGiftListDetails = this.props.guestViewGiftListData ? this.props.guestViewGiftListData : '';
    this.addressId = '';
    this.recipientIndex = '';
    this.eventRecipientIndex = '';
    this.itemDataForPopup = {};
    this.ownerName = '';
    this.category = '';
    this.index = '';
    this.state = {
      isFav: false,
      addToCartSuccess: false,
      expressCheckoutEnabled: false,
      numericQuantity: this.quantity,
      isHelp: false
    };
    this.selectGifteePerson = undefined;
    //this.getConfiguration();
  }

  productTypeMap = {
    SOFT_LINE: 'SL',
    GIFT_CERTIFICATE: 'GC',
    BIG_TICKET: 'BT'
  };

  // getConfiguration = () => {
  //   const payload = {
  //     brandName: commonUtil.getBrand(),
  //   };
  //   getConfiguration(payload).then((response) => {
  //     if (response.body.status.status === 'SUCCESS') {
  //       if (response.body.configuration && response.body.configuration.expressCheckoutConfiguration) {
  //         const expressCheckoutEnabled = response.body.configuration.expressCheckoutConfiguration.expressCheckoutEnabled === 'true';
  //         this.setState({ expressCheckoutEnabled });
  //       }
  //     }
  //   // eslint-disable-next-line no-console
  //   }).catch((e) => { console.log(e); }); // console required
  // }

  selectedCelebrityData = (event) => {
    const selectedCelebratedId = event.id.replace('id_', '');
    this.addressId = _.find(this.props.guestViewGiftListData && this.props.guestViewGiftListData.celebratedList, { celebratedId: selectedCelebratedId }).addressId;
    this.recipientIndex = event.value;
    this.ownerName = event.displayName;
  }

  showContent = (itemData, categoryName) => {
    this.itemDataForPopup = itemData;
    this.setState({ isFav: this.itemDataForPopup.isFavourite , numericQuantity: itemData.quantity || 1});
    this.resetModalData();
    this.contentModal.handleShow();
    if (this.counter) this.counter.setDefaultValue(1);
    const imgRef = document.querySelector('#productModal div.productImgModal img');
    if (categoryName === commonUtil.getLabel(this.props.labels.GuestviewPage, 'guestview.gift.certificate.name.label')) {
      imgRef.src = commonUtil.getAssetURL() + '/images/certificado.jpg';
      if (this.counter) this.counter.makeDisable(false);
    } else {
      imgRef.src = itemData.imageURL || commonUtil.getAssetURL() + "/images/guest/no-image.png";
      if (this.counter) this.counter.makeDisable(false);
    }
    const productName = document.querySelector('#productModal p.titleProductModal');
    productName.innerText = itemData.name;
    const skuId = document.querySelector('#productModal p.skuId');
    skuId.innerHTML = `<strong>SKU:</strong> ${itemData?.skuId || ''}`;
    if (Number(itemData.salePrice) < Number(itemData.listPrice) && categoryName !== commonUtil.getLabel(this.props.labels.GuestviewPage, 'guestview.gift.certificate.name.label')) {
      const salePrice = document.querySelector('#productModal p.salePrice');
      salePrice.innerHTML = commonUtil.getHtmlCurrency(itemData.listPrice);
      const priceProduct = document.querySelector('#productModal p.priceProduct');
      priceProduct.innerHTML = commonUtil.getHtmlCurrency(itemData.salePrice);
    } else {
      const salePrice = document.querySelector('#productModal p.priceProduct');
      salePrice.innerHTML = commonUtil.getHtmlCurrency(itemData.listPrice);
    }
    this.gifteeRefs.forEach((rad) => {
      if (rad != null) {
        rad.setChecked(false);
        if (rad.props.id === this.props.gifteeId) {
          rad.setChecked(true);
        }
      }
    });
    this.celebratedId = this.props.gifteeId;
    const celebrity = _.find(this.props.celebratedList, { celebratedId: this.celebratedId });
    this.recipientIndex = celebrity ? celebrity.recipientIndex : '';
    this.addressId = celebrity ? celebrity.addressId : this.guestViewGiftListDetails.celebratedList[0].addressId;
    this.itemInfo = {
      productName: itemData.name,
      productType: itemData.productType,
      deliveryMode: itemData.deliveryMode,
      skuId: itemData.skuId,
      listPrice: itemData.listPrice,
      salePrice: itemData.salePrice,
      quantity: this.counter && this.counter.count,
    };
    if (itemData.departmentId !== '') { this.itemInfo.departmentId = itemData.departmentId; }
    if (itemData.color !== '') { this.itemInfo.color = itemData.color; }
    if (itemData.size !== '') { this.itemInfo.size = itemData.size; }
    if (itemData.texture !== '') { this.itemInfo.texture = itemData.texture; }
    if (itemData.material !== '') { this.itemInfo.material = itemData.material; }
    if (itemData.imageURL !== '') { this.itemInfo.imageURL = itemData.imageURL; }
    this.category = categoryName;

    const dataLayer = {
      event: 'view_item',
      seccion: 'Mesa de regalos',
      phase: 'Mesa de regalos',
      phase_detail: 'Lista del festejado',
      list: `${this.props.eventId} | Lista mesa`,
      value: `${itemData.salePrice * this.counter?.count}`,
      currency: 'MXN',
      items: [{
        item_id: itemData.skuId,
        item_variant: itemData.skuId,
        item_name: itemData.name,
        item_category: categoryName,
        price: itemData.salePrice,
        original_price: itemData.listPrice,
        quantity: this.counter?.count,
        gift_list_number: `${this.props.eventId}`,
      }],
    };
    window.dataLayer.push(dataLayer);
  }


  componentDidUpdate(prevProps) {
  if (!prevProps.addToCartSuccess && this.props.addToCartSuccess) {
    this.props.getCartCountData();
    this.props.getGiftListGuestView(this.eventId, 'Ascending', '', '1', 'false', '52');
    this.setState({ addToCartSuccess: true });
    this.props.clearFilter();
    this.props.displayAlertMessage(commonUtil.getLabel(this.props?.labels?.GuestviewPage, 'guestview.gift.added.to.cart.success.message'), 'success');
    this.closeModal();
  }

  if (this.props.addToCartError && prevProps.addToCartError !== this.props.addToCartError) {
    console.error('Add to cart failed:', this.props.addToCartError);
    const errorMsg = 
      typeof this.props.addToCartError === 'string' ? this.props.addToCartError :
      this.props.addToCartError?.errorMessage ||
      this.props.addToCartError?.message ||
      'Add to cart failed.';
    this.props.displayAlertMessage(errorMsg, 'error');
    this.closeModal();
  }

  if (!prevProps.expressCheckoutSuccess && this.props.expressCheckoutSuccess) {

    const isLoggedIn = !!(this.props?.user?.emailId || this.props?.user?.profileId);

    if (isLoggedIn) {
      location.href = serverClientUtil.getLPURL() + '/tienda/oneCheckout?isBuyNow=true';
    } else {
      commonUtil.handleRedirect(true);
    }

   // this.props.displayAlertMessage('Express checkout successful!', 'success');
    this.closeModal();
  }

  if (this.props.expressCheckoutError && prevProps.expressCheckoutError !== this.props.expressCheckoutError) {
    console.error('Express checkout failed:', this.props.expressCheckoutError);
    const errorMsg =
      typeof this.props.expressCheckoutError === 'string' ? this.props.expressCheckoutError :
      this.props.expressCheckoutError?.errorMessage ||
      this.props.expressCheckoutError?.message ||
      'Express checkout failed.';
    this.props.displayAlertMessage(errorMsg, 'error');
    this.closeModal();
  }
}

  sanitizeAddress = (address) => {
    if (!address || typeof address !== "object") return {};
  
    return {
      firstName: address.firstName || "",
      lastName: address.lastName || "",
      country: address.country || "",
      phoneNumber: address.phoneNumber || "",
      address2: address.address2 || "",
      city: address.city || "",
      address1: address.address1 || "",
      postalCode: address.postalCode || "",
      state: address.state || ""
    };
  }

  handleUserAction = async () => {
    await commonUtil.ensureAnonymousSession(this.props?.user);
    // let isChecked = false;
    // this.gifteeRefs = _.compact(this.gifteeRefs);
    // for (let i = 0; i < this.gifteeRefs.length; ++i) {
    //   if (this.gifteeRefs[i].isChecked()) {
    //     isChecked = this.gifteeRefs[i].isChecked();
    //     break;
    //   }
    // }
    // if (this.gifteeRefs.length === 0) {
    //   isChecked = true;
    // }

    // if (isChecked) {
    //   document.querySelector('span.error').style.display = 'none';
    // } else {
    //   document.querySelector('span.error').style.display = 'block';
    //   return;
    // }
    _.merge(this.itemInfo, { quantity: this.quantity });
    // this.quantity = this.counter && this.counter.count;
    // this.quantity = this.state.numericQuantity || this.quantity;
    this.eventRecipientIndex = this.itemDataForPopup.eventRecipientIndex ? this.itemDataForPopup.eventRecipientIndex : '';
    const addressTempId = (this.itemDataForPopup.addressId && this.itemDataForPopup.addressId.trim().length > 2) ?
      this.itemDataForPopup.addressId.trim() : this.addressId;
    //   const isCommerceEnabled = (document.cookie.indexOf('gcp-migrated=true') !== -1);
    // let addItemToCartDetails = {
    //   brand: commonUtil.getBrand(),
    //   channel:'web',
    //   sku: this.itemInfo.skuId,
    //   quantity: Number(this.quantity),
    //   // serviceSku: this.itemInfo.skuId,
    //   eventId: this.guestViewGiftListDetails.eventInfo.eventId,
    //   // eventInfo: {
    //   //   eventId: this.guestViewGiftListDetails.eventInfo.eventId,
    //   //   eventType: this.guestViewGiftListDetails.eventInfo.eventType,
    //   //   eventDate: this.guestViewGiftListDetails.eventInfo.eventDate,
    //   //   celebrity1Name: this.guestViewGiftListDetails.celebratedList[0].celebratedName,
    //   //   recipientIndex: this.eventRecipientIndex.trim() !== '' ? parseInt(this.eventRecipientIndex, 10) : parseInt(this.recipientIndex, 10),
    //   //   ownerName: this.ownerName ? this.ownerName : _.find(this.guestViewGiftListDetails.celebratedList, { celebratedId: this.props.gifteeName }).celebratedName,
    //   //   address: 'address',
    //   // },
    // };
    // if (this.guestViewGiftListDetails.celebratedList && this.guestViewGiftListDetails.celebratedList[1] && this.guestViewGiftListDetails.celebratedList[1] !== '') {
    //   addItemToCartDetails.eventInfo.celebrity2Name = this.guestViewGiftListDetails.celebratedList[1].celebratedName;
    // }
    // if (this.recipientIndex && this.eventRecipientIndex.trim() !== '' && this.recipientIndex !== this.eventRecipientIndex) {
    //   addItemToCartDetails.eventInfo.selectedRecipientIndex = parseInt(this.recipientIndex, 10);
    // }
    this.eventRecipientIndex = this.itemDataForPopup.eventRecipientIndex ? this.itemDataForPopup.eventRecipientIndex : '';
    const addItemToCartDetails = {
        brand: commonUtil.getBrand(),
        channel:'WEB',
        productInfo: this.itemInfo,
        eventInfo: {
          eventId: this.guestViewGiftListDetails.eventInfo.eventId,
          eventType: this.guestViewGiftListDetails.eventInfo.eventType,
          eventDate: this.guestViewGiftListDetails.eventInfo.eventDate,
          celebrity1Name: this.guestViewGiftListDetails.celebratedList[0].celebratedName,
          recipientIndex: this.eventRecipientIndex.trim() !== '' ? parseInt(this.eventRecipientIndex, 10) : this.recipientIndex.trim() !== '' ? parseInt(this.recipientIndex, 10) : 1,
          ownerName: this.ownerName ? this.ownerName : !_.isEmpty(this.props.gifteeName) ? _.find(this.guestViewGiftListDetails.celebratedList, { celebratedId: this.props.gifteeName }).celebratedName : this.guestViewGiftListDetails.celebratedList[0].celebratedName,
          address: 'address',
        },
      };
  
      addItemToCartDetails.productInfo.productType = this.productTypeMap[this.itemInfo.productType] ?? this.itemInfo.productType;
      addItemToCartDetails.productInfo.quantity = Number(addItemToCartDetails.productInfo.quantity);
      if (this.guestViewGiftListDetails.celebratedList && this.guestViewGiftListDetails.celebratedList[1] && this.guestViewGiftListDetails.celebratedList[1] !== '') {
        addItemToCartDetails.eventInfo.celebrity2Name = this.guestViewGiftListDetails.celebratedList[1].celebratedName;
      }
      if (this.recipientIndex && this.eventRecipientIndex.trim() !== '' && this.recipientIndex !== this.eventRecipientIndex) {
        addItemToCartDetails.eventInfo.selectedRecipientIndex = parseInt(this.recipientIndex, 10);
      }
      if(addressTempId){
        addItemToCartDetails.eventInfo.address = this.props.guestViewGiftListData.addressInfo.find(address => address.addressId == addressTempId);
      }else{
        addItemToCartDetails.eventInfo.address = this.props.guestViewGiftListData.addressInfo[0];
      }

      const address = addItemToCartDetails?.eventInfo?.address;
      if (address && typeof address === "object" && Object.keys(address).length) {
        addItemToCartDetails.eventInfo.address = this.sanitizeAddress(address);
      }

      this.props.additemtocart(addItemToCartDetails);
    // this.props.additemtocart(addItemToCartDetails).then((response) => {
    //   console.log('addItemToCart response ==',response); // console required
    //   if (response.body.status && response.body.status.status === 'success') {
    //     const data = addItemToCartDetails;
    //     this.props.getCartCountData();
    //     this.props.getGiftListGuestView(this.eventId, 'Ascending', '', '1', 'false', '52');
    //     this.setState({ addToCartSuccess: true });
    //     this.props.clearFilter();
    //     if (document.querySelector('span.error') && (this.state.addToCartSuccess === true)) { document.querySelector('span.error').style.display = 'none'; }
    //     this.getAddressObject = {};
    //     const dataLayer = {
    //       event: 'add_to_cart',
    //       value: `${data.productInfo.quantity * data.productInfo.salePrice}`,
    //       currency: 'MXN',
    //       phase: 'Lista de regalos',
    //       phase_detail: 'Agregar a mi bolsa',
    //       seccion: 'Mesa de regalos',
    //       items: [{
    //         affiliation: 'Liverpool',
    //         item_id: `${data.productInfo.skuId}`,
    //         item_variant: `${data.productInfo.skuId}`,
    //         item_name: `${data.productInfo.productName}`,
    //         item_brand: '',
    //         item_category: `${this.category}`,
    //         price: `${data.productInfo.salePrice}`,
    //         quantity: `${data.productInfo.quantity}`,
    //         index: this.index,
    //         promotion_name: '',
    //         numero_mesa: `${data.eventInfo.eventId}`,
    //         original_price: `${data.productInfo.listPrice}`,
    //         item_color: `${data.productInfo.color ? data.productInfo.color : ''}`,
    //         item_size: `${data.productInfo.size ? data.productInfo.size : ''}`,
    //         gif_list_number: `${data.eventInfo.eventId}`,
    //       }],
    //     };
    //     const _dataLayer = {
    //       event: 'alerta',
    //       phase: 'Lista del festejado',
    //       step: 'Agregar a la bolsa',
    //       mensaje: `${commonUtil.getLabel(this.lables.GuestviewPage, 'guestview.you.added.by.label')} ${this.quantity} ` +
    //       commonUtil.getLabel(this.lables.GuestviewPage, this.quantity < 2 ? 'guestview.product.by.label' : 'guestview.products.by.label') + ' ' +
    //       commonUtil.getLabel(this.lables.GuestviewPage, 'guestview.to.your.bag.by.label'),
    //       mensaje_servicio: `${response.body.status.status}`,
    //       seccion: 'Mesa de regalos',
    //       tipo: 'pop-up',
    //     };
    //     window.dataLayer.push(dataLayer);
    //     window.dataLayer.push(_dataLayer);
    //   } else if (response.body.status === 'failure') {
    //     // this.warning.setMessage(commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.add.gift.certificate.personal.event.error.message'));
    //     this.warning.setMessage(response.body.message || this.errorMessage);
    //     this.closeModal()
    //   } else {
    //     this.warning.setMessage(this.errorMessage);
    //     this.closeModal()
    //   }
    // // eslint-disable-next-line no-console
    // }).catch((e) => { console.log(e); }); // console required
  }

  handleUserExpressCheckoutBuyNowAction = async () => {
    // let isChecked = false;
    // this.gifteeRefs = _.compact(this.gifteeRefs);
    // for (let i = 0; i < this.gifteeRefs.length; ++i) {
    //   if (this.gifteeRefs[i].isChecked()) {
    //     isChecked = this.gifteeRefs[i].isChecked();
    //     break;
    //   }
    // }
    // if (this.gifteeRefs.length === 0) {
    //   isChecked = true;
    // }
    // if (isChecked) {
    //   document.querySelector('span.error').style.display = 'none';
    // } else {
    //   document.querySelector('span.error').style.display = 'block';
    //   return;
    // }
    _.merge(this.itemInfo, { quantity: this.quantity });
    // this.quantity = this.state.numericQuantity || this.quantity;
    this.eventRecipientIndex = this.itemDataForPopup.eventRecipientIndex ? this.itemDataForPopup.eventRecipientIndex : '';
    const addressTempId = (this.itemDataForPopup.addressId && this.itemDataForPopup.addressId.trim().length > 2) ?
      this.itemDataForPopup.addressId.trim() : this.addressId;
    // const addItemToCartDetails = {
    //   addressId: addressTempId,
    //   brandName: commonUtil.getBrand(),
    //   productInfo: this.itemInfo,
    //   eventInfo: {
    //     eventId: this.guestViewGiftListDetails.eventInfo.eventId,
    //     eventType: this.guestViewGiftListDetails.eventInfo.eventType,
    //     eventDate: this.guestViewGiftListDetails.eventInfo.eventDate,
    //     celebrity1Name: this.guestViewGiftListDetails.celebratedList[0].celebratedName,
    //     recipientIndex: this.eventRecipientIndex.trim() !== '' ? parseInt(this.eventRecipientIndex, 10) : parseInt(this.recipientIndex, 10),
    //     ownerName: this.ownerName ? this.ownerName : _.find(this.guestViewGiftListDetails.celebratedList, { celebratedId: this.props.gifteeName }).celebratedName,
    //     address: 'address',
    //   },
    // };
    // const isCommerceEnabled = (document.cookie.indexOf('gcp-migrated=true') !== -1);
    // let addItemToCartDetails = {
    //   brand: commonUtil.getBrand(),
    //     channel:'web',
    //     items: [
    //       {
    //         sku: this.itemInfo.skuId,
    //         quantity: Number(this.quantity),
    //         serviceSku: this.itemInfo.skuId,
    //         // eventInfo: {
    //         //   eventId: this.guestViewGiftListDetails.eventInfo.eventId,
    //         //   eventType: this.guestViewGiftListDetails.eventInfo.eventType,
    //         //   eventDate: this.guestViewGiftListDetails.eventInfo.eventDate,
    //         //   celebrity1Name: this.guestViewGiftListDetails.celebratedList[0].celebratedName,
    //         //   recipientIndex: this.eventRecipientIndex.trim() !== '' ? parseInt(this.eventRecipientIndex, 10) : parseInt(this.recipientIndex, 10),
    //         //   ownerName: this.ownerName ? this.ownerName : _.find(this.guestViewGiftListDetails.celebratedList, { celebratedId: this.props.gifteeName }).celebratedName,
    //         //   address: 'address',
    //         // },

    //         }
    //     ]
    // };
    // if (this.guestViewGiftListDetails.celebratedList && this.guestViewGiftListDetails.celebratedList[1] && this.guestViewGiftListDetails.celebratedList[1] !== '') {
    //   addItemToCartDetails.eventInfo.celebrity2Name = this.guestViewGiftListDetails.celebratedList[1].celebratedName;
    // }
    // if (this.recipientIndex && this.eventRecipientIndex.trim() !== '' && this.recipientIndex !== this.eventRecipientIndex) {
    //   addItemToCartDetails.eventInfo.selectedRecipientIndex = parseInt(this.recipientIndex, 10);
    // }

    this.eventRecipientIndex = this.itemDataForPopup.eventRecipientIndex ? this.itemDataForPopup.eventRecipientIndex : '';
     const addItemToCartDetails = {
        brand: commonUtil.getBrand(),
        channel:'web',
        productInfo: this.itemInfo,
        eventInfo: {
          eventId: this.guestViewGiftListDetails.eventInfo.eventId,
          eventType: this.guestViewGiftListDetails.eventInfo.eventType,
          eventDate: this.guestViewGiftListDetails.eventInfo.eventDate,
          celebrity1Name: this.guestViewGiftListDetails.celebratedList[0].celebratedName,
          recipientIndex: this.eventRecipientIndex.trim() !== '' ? parseInt(this.eventRecipientIndex, 10) : parseInt(this.recipientIndex, 10),
          ownerName: this.ownerName ? this.ownerName : !_.isEmpty(this.props.gifteeName) ? _.find(this.guestViewGiftListDetails.celebratedList, { celebratedId: this.props.gifteeName }).celebratedName : this.guestViewGiftListDetails.celebratedList[0].celebratedName,
          address: 'address',
        },
      };
      if (this.guestViewGiftListDetails.celebratedList && this.guestViewGiftListDetails.celebratedList[1] && this.guestViewGiftListDetails.celebratedList[1] !== '') {
        addItemToCartDetails.eventInfo.celebrity2Name = this.guestViewGiftListDetails.celebratedList[1].celebratedName;
      }
      if (this.recipientIndex && this.eventRecipientIndex.trim() !== '' && this.recipientIndex !== this.eventRecipientIndex) {
        addItemToCartDetails.eventInfo.selectedRecipientIndex = parseInt(this.recipientIndex, 10);
      }
      
      addItemToCartDetails.productInfo.productType = this.productTypeMap[this.itemInfo.productType] ?? this.itemInfo.productType;
      addItemToCartDetails.productInfo.quantity = Number(addItemToCartDetails.productInfo.quantity);

      if(addressTempId){
        addItemToCartDetails.eventInfo.address = this.props.guestViewGiftListData.addressInfo.find(address => address.addressId == addressTempId);
      }else{
        addItemToCartDetails.eventInfo.address = this.props.guestViewGiftListData.addressInfo[0];
      }

      const address = addItemToCartDetails?.eventInfo?.address;
      if (address && typeof address === "object" && Object.keys(address).length) {
        addItemToCartDetails.eventInfo.address = this.sanitizeAddress(address);
      }

    await commonUtil.ensureAnonymousSession(this.props?.user);

    this.props.additemtoexpresscart(addItemToCartDetails);

    // additemtoexpresscart(addItemToCartDetails).then(async (response) => {
    //   if (response.body.s === '0') {
    //     const data = addItemToCartDetails;
    //     const dataLayer = {
    //       event: 'add_to_cart',
    //       value: `${data.productInfo.quantity * data.productInfo.salePrice}`,
    //       currency: 'MXN',
    //       phase: 'Lista de regalos',
    //       phase_detail: 'Comprar ahora',
    //       seccion: 'Mesa de regalos',
    //       items: [{
    //         affiliation: 'Liverpool',
    //         item_id: `${data.productInfo.skuId}`,
    //         item_variant: `${data.productInfo.skuId}`,
    //         item_name: `${data.productInfo.productName}`,
    //         item_brand: '',
    //         item_category: `${this.category}`,
    //         price: `${data.productInfo.salePrice}`,
    //         quantity: `${data.productInfo.quantity}`,
    //         index: this.index,
    //         promotion_name: '',
    //         numero_mesa: `${data.eventInfo.eventId}`,
    //         original_price: `${data.productInfo.listPrice}`,
    //         item_color: `${data.productInfo.color ? data.productInfo.color : ''}`,
    //         item_size: `${data.productInfo.size ? data.productInfo.size : ''}`,
    //         gif_list_number: `${data.eventInfo.eventId}`,
    //       }],
    //     };
    //     window.dataLayer.push(dataLayer);
    //     const LoggedInSession = GetCookie('LoggedInSession');
    //     const LoginStatus = GetCookie('LoginStatus');
    //     if ((LoggedInSession !== '' && LoggedInSession === 'TRUE') || (LoginStatus !== '' && LoginStatus === 'Success')) {
    //       location.href = serverClientUtil.getLPURL() + '/tienda/oneCheckout';
    //     } else {
    //       window.sessionStorage.setItem('cartToCheckoutCustomRoute', '/tienda/checkoutShipping');
    //       setTimeout(() => {
    //         location.href = serverClientUtil.getLPURL() + '/tienda/login?pageName=fromgr';
    //       }, 3000);
    //     }
    //     this.props.clearFilter();
    //   } else if (response.body.s === '1') {
    //     this.warning.setMessage(commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.add.gift.certificate.personal.event.error.message'));
    //   } else {
    //     this.warning.setMessage(this.errorMessage);
    //   }
    // // eslint-disable-next-line no-console
    // }).catch((e) => { console.log(e); }); // console required
  }

  resetModalData = () => {
    this.setState({ addToCartSuccess: false });
    if (document.querySelector('span.error') || (this.state.addToCartSuccess === true)) {
      document.querySelector('span.error').style.display = 'none';
    }
    if (this.warning && this.warning.setMessage()) {
      this.warning.hideErrorMsg();
    }
  };

  closeModal = () => {
    this.setState({
      addToCartSuccess: false,
    });
    this.quantity = 1;
    this.contentModal.handleHide();
  }
  handleQuantityChange = (e) => {
    const value = e.target.value;
    
    if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
      this.setState({ numericQuantity: Number(value) });
      this.quantity = Number(value); 
  }
}

    handleIncrement = () => {
    this.setState((prevState) => {
      const newQty = Math.min(999, Number(prevState.numericQuantity || 0) + 1);
      // this.props.onQuantityChange?.(newQty);
      this.quantity = this.quantity+1;
      return { numericQuantity: newQty };
    });
  };

   handleDecrement = () => {
    this.setState((prevState) => {
      const newQty = Math.max(0, Number(prevState.numericQuantity || 0) - 1);
      // this.props.onQuantityChange?.(newQty);
      this.quantity = this.quantity-1;
      return { numericQuantity: newQty };
    });
  };

  handleHelpIconClick = (show) => {
    this.setState({
      isHelp: show,
    });
  };

  render() {
    // debugger;
    const { guestViewGiftListData } = this.props;
    this.lables = this.props.labels;
    this.errorMessage =
      commonUtil.getLabel(this.lables.GuestviewPage, 'adminpage.addcart.service.fail.msg') + '.' + commonUtil.getLabel(this.lables.GuestviewPage, 'adminpage.addcart.service.fail.msg1') + '.';
    const AddToBagButton = {
      type: 'button',
      value: commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.addtocart.button.label'),
      autoFocus: false,
      style: 'btnPrimary btnGiftSmall btnPrimarySpecial',
      onClickHandler: this.handleUserAction,
    };
    const ContinueShoppingButton = {
      type: 'button',
      value: commonUtil.getLabel(this.lables.EventAdminPage, 'adminpage.button.continue.buying'),
      autoFocus: false,
      style: 'btnPrimary continueShopping',
      onClickHandler: this.closeModal,
    };
    const ExpressCheckoutBuyNow = {
      type: 'button',
      value: 'Comprar ahora',
      autoFocus: false,
      style: 'btnPrimary btnGiftSmall',
      onClickHandler: this.handleUserExpressCheckoutBuyNowAction,
    };
    const counterData = {
      inputBox_Id: 'quantity',
      max_length: 999,
      min_length: 1,
    };
    const _imgsrc = [
      {
        media: '(max-width: 465px)',
        srcSet: '',
      },
    ];

    const imageAttr = {
      src: '',
      id: 'm-link',
      altImg: this.itemDataForPopup?.altImageUrl || commonUtil.getAssetURL() + "/images/guest/no-image.png",
      width: 'auto',
      height: 'auto',
      pictureHtmlStyle: {
        alignPicture: 'center'
      }
    };
    if (guestViewGiftListData && guestViewGiftListData.celebratedList && guestViewGiftListData.celebratedList.length) {
      const celebratedList = guestViewGiftListData.celebratedList;
      if (celebratedList.length > 1) {
        this.selectGifteePerson = {
          name: 'selectGifteePerson',
          options: [],
        };

        this.selectGifteePerson.options = celebratedList.map(giftee => ({
          id: giftee.celebratedId,
          value: giftee.recipientIndex,
          displayName: giftee.celebratedName,
          subDetailsHTML: <p>{giftee.celebratedName}</p>,
          defaultChecked: this.props.gifteeId.toString() === giftee.celebratedId && giftee.celebratedId.length > 0,
        }));
      } else {
        this.selectGifteePerson = {
          id: celebratedList[0].celebratedId,
          value: celebratedList[0].recipientIndex,
          displayName: celebratedList[0].celebratedName,
        };
        this.selectedCelebrityData(this.selectGifteePerson);
      }
    }
    this.gifteeRefs = [];
    return (
      <React.Fragment>
        <Tagging ref={tagging => this.tagging = tagging} />
        {
          this.props.guestViewGiftListData.itemsInfo ?
          this.props.guestViewGiftListData.itemsInfo.map(categoryInfo =>
          (<ListItem
            categoryInfo={categoryInfo}
            showContent={this.showContent}
            labels={this.props.labels}
            eventId={this.guestViewGiftListDetails.eventInfo.eventId}
          />)) : null
        }
        <ModalPopover
          ref={content => this.contentModal = content}
          isModal="true"
          modalId="productModal"
          modalClass="gift-modal gift-guest right-slide-modal gift-registered-modal-open"
        >
          <div>
            <div className='productModalHeader'>
              <span class="guest-header-text">Compra para mesa de regalos</span>
              <button onClick={this.closeModal} className="guest-icon-button" aria-label="Close">
                {closeWebGiftListIcon}
              </button>
            </div>
            {/* <button id="closeModal" className="btnClose" onClick={this.closeModal}><i className="icon-tache2" /></button> */}
            <div className="clearfix" />
            <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />

            <div className='guest-gift-list-data-wrapper'>
                <div className='productImgModal'>
                        <Image imageAttr={imageAttr} _imgsrc={_imgsrc} />
                  </div>
                <div className="row guest-gift-list-product-data">
                 <p className="titleProductModal" />
                  {/* {this.state.isFav ?
                    <p>
                      <i className="icon-estrella_negativo flagModal" />
                      <span>{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.favourite.label')}</span>
                    </p> :
                    null
                  } */}
                  <p className="skuId" />
                  <p className="salePrice" />
                  <p className="priceProduct" />
                  {/* {this.state.addToCartSuccess === false ?
                    <React.Fragment>
                      <p className="qntTitle" id="qntTitle">{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.quantity.label')}</p>
                      <div className="input-group quantityGroupGift" id="quantityGroupGift">
                        <Counter
                          ref={counter => this.counter = counter}
                          inputBox_Id={counterData.inputBox_Id}
                          max_length={counterData.max_length}
                          min_length={counterData.min_length}
                        />
                      </div>
                    </React.Fragment> : null} */}
                </div>
                </div>
                {/* <div className="row">
                  {this.state.addToCartSuccess ?
                    <div className="col-md-12 productAdded" id="productAdd" style={{ display: 'block' }}>
                      <i className="icon-estado_de_mensaje_aprobado">
                        <span>
                          {commonUtil.getLabel(this.lables.GuestviewPage, 'guestview.you.added.by.label')}
                          <b> {this.quantity} {commonUtil.getLabel(this.lables.GuestviewPage, this.quantity < 2 ? 'guestview.product.by.label' : 'guestview.products.by.label')}</b>&nbsp;
                          {commonUtil.getLabel(this.lables.GuestviewPage, 'guestview.to.your.bag.by.label')}
                        </span>
                      </i>
                      <InputButton buttonAttr={ContinueShoppingButton} />
                    </div> :
                    <div className="col-md-12 selectCustomer" id="selectCustomers" >
                      <p>{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.giftbuyinfor.label')}</p>

                      <span className="error" style={{ display: 'none' }}>{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.owner.selection.bcc.text')}</span>

                      {this.selectGifteePerson && this.selectGifteePerson.options && this.selectGifteePerson.options.map((option, index) => (
                        <RadioButton
                          changeOnPropsChange
                          ref={rad => this.gifteeRefs.push(rad)}
                          name={this.selectGifteePerson.name}
                          checked={option.defaultChecked}
                          id={'id_' + option.id}
                          key={index}
                          value={option.value}
                          displayName={option.displayName}
                          radioCssClass={'radio'}
                          onChangeFunction={event => this.selectedCelebrityData(event)}
                        />
                      ))}
                      {this.selectGifteePerson && !this.selectGifteePerson.options && <p>{this.selectGifteePerson.displayName}</p>}
                       <InputButton buttonAttr={ExpressCheckoutBuyNow} /> 
                       <InputButton buttonAttr={AddToBagButton} />
                    </div>}
                </div>
              </div>
            </div>
            <div className="clearfix" />
          </div>
        </ModalPopover> */}
         <div className="guest-gift-list-product-quantity-wrapper ">
              <div className="quantity">{'Cantidad'}</div>
              <div className="quantity-wrapper-guestlist">
                <div className="">
                  <span
                    className="btn btn-default gift-quantity-btns"
                    onClick={this.quantity <= 1 ? null : this.handleDecrement}
                    disabled={this.quantity <= 1}
                  >
                    {this.quantity <= 1 ? (deleteWebModalIcon) : (<span className='glyphicon glyphicon-minus' />)}
                  </span>
                </div>
                <div className=''>
                  <TextInput className="text-center input-number gift-quantity number-input-no-arrows" 
                  parentClassName="text_input_wrapper"
                  value={this.quantity} 
                  name='quantity'
                   type="number"
                    min="0"
                    numeric ='numeric'
                    onKeyDown={(e) => {
                       if (e.key === "-" || e.key === "e") {
                         e.preventDefault();
                    }
                    }}
                   onPaste={(e) => {
                          const pasted = e.clipboardData.getData("text");
                     if (pasted.includes("-") || isNaN(pasted) || Number(pasted) < 0) {
                     e.preventDefault();
                  }
                  }}
                  onChange={this.handleQuantityChange}
                   />
                </div>
                <div className="">
                  <span
                    className="btn btn-default gift-quantity-btns"
                    onClick={this.handleIncrement}
                  >
                    {AddWebModalIcon}
                  </span>
                </div>
              </div>
            </div> 
            {
              this.state.isFav &&
              <div className='favorite-and-buttons-wrapper-guestlist'>
                <div className="help-text-wrapper">
                <p className="favorite-text">Regalo favorito</p>
                <span className='help-icon-guestlist' onMouseOver={() => this.handleHelpIconClick(true)} onMouseLeave={() => this.handleHelpIconClick(false)}>{helpWebGiftListIcon}</span>
                </div>
                <span className='star-icon-guestlist'>{starWebGiftListIcon}</span>
                <p className='help-icon-text-container' style={{display: this.state.isHelp ? 'inline-block':'none'}}>El festejado lo eligió como uno de sus regalos más deseados.</p>
              </div>
            }
            < div className="buttons_wap_gift_wrapper" >
             <InputButton buttonAttr={AddToBagButton} />
             <InputButton buttonAttr={ExpressCheckoutBuyNow} /> 
            </div>
            <div className="clearfix" />
          </div>
        </ModalPopover>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  gifteeName: state.giftListGuestViewList.gifteeName,
  celebratedList: state.giftListGuestViewList.data.celebratedList,
  addToCartSuccess: state.giftListGuestViewList.addToCartSuccess,
  addToCartError: state.giftListGuestViewList.addToCartError,
  addToCartResponse: state.giftListGuestViewList.addToCartResponse,
  expressCheckoutSuccess: state.giftListGuestViewList.expressCheckoutSuccess,
  expressCheckoutError: state.giftListGuestViewList.expressCheckoutError,
  expressCheckoutResponse: state.giftListGuestViewList.expressCheckoutResponse,
  user: state.user && state.user.data && state.user.data.result,
});

const matchDispatchToProps = dispatch => bindActionCreators(
  {
    getCartCountData,
    additemtocart,
    additemtoexpresscart
  }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(ListContainer);
